import { Story, SubStory } from '@frontend/sports/types/components/story-content';

import { Promotion } from '../crm-offer-data/crm-offer.model';

export enum StoryContentConstants {
    TrackingCategoryEvent = 'Module',
    TrackingLabelEvent = 'Onboarding Stories',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    SwipeDeltaYValue = 15,
}

export enum SubStoryType {
    Image = 'Image',
    Video = 'Video',
    // no real clue how to fix, as it should not happen at all
    // eslint-disable-next-line @typescript-eslint/no-shadow
    Promotion = 'Promotion',
}

export enum StoryNavigation {
    NextStory,
    PreviousStory,
    NextSubStory,
    NextSubStoryWithoutTracking,
    PreviousSubStory,
}

export interface StoryContentTrackingData {
    action: TrackingActionEvent;
    position: string;
    location: string;
    eventDetails: TrackingEventDetails;
    index?: number;
}

export enum TrackingActionEvent {
    Load = 'Load',
    Exit = 'Exit',
    Click = 'Click',
}

export enum TrackingEventDetails {
    OnboardingStoriesModule = 'Onboarding Stories Module',
    DismissOnboardingStoriesModule = 'Dismiss Onboarding Stories Module',
    StoryTile = 'Story Tile',
    // no real clue how to fix, as it should not happen at all
    // eslint-disable-next-line @typescript-eslint/no-shadow
    Story = 'Story',
    Substory = 'Substory',
    NextStory = 'Next Story',
    NextSubstory = 'Next Substory',
    PreviousStory = 'Previous Story',
    PreviousSubstory = 'Previous Substory',
    DismissStory = 'Dismiss Story',
    SeeMore = 'See More',
    OptIn = 'Opt-in',
    Done = 'Done',
}

export interface ContentSubStory extends SubStory {
    readonly type: SubStoryType;
}

export interface PromotionSubStory extends ContentSubStory {
    readonly type: SubStoryType.Promotion;
    promotion: Promotion;
}

export interface VideoSubStory extends ContentSubStory {
    readonly type: SubStoryType.Video;
}

export interface ImageSubStory extends ContentSubStory {
    readonly type: SubStoryType.Image;
}

export interface ContentStory extends Omit<Story, 'subStories'> {
    subStories: ContentSubStory[];
}
export interface StoryDetails {
    storyId: string;
    subStoryId: string;
}

export interface NavigationPayload {
    action: StoryNavigation;
    payload: StoryDetails;
}
